<template>
  <div class="work-item-row d-flex align-items-center flex-wrap py-3 px-4 border-bottom" :class="{ 'work-item-exception': isException }">
    <!-- Identity block -->
    <div class="work-item-identity pr-3">
      <div class="font-weight-bolder text-dark">
        <a
          v-if="item.clientId"
          href="#"
          class="text-dark"
          @click.prevent="$router.push(`/workbench/clients/${item.clientId}`)"
        >{{ item.client }}</a>
        <span v-else>{{ item.client }}</span>
      </div>
      <div class="text-muted font-size-sm">
        <a
          v-if="item.policyId"
          href="#"
          class="font-weight-bold text-dark-50"
          @click.prevent="$router.push(`/workbench/policies/${item.policyId}`)"
        >{{ item.policyNumber }}</a>
        <span v-else class="font-weight-bold text-dark-50">{{ item.policyNumber }}</span>
        <span class="mx-1">&middot;</span>{{ item.txnType }}
        <span class="mx-1">&middot;</span>{{ item.brand }}
      </div>
      <div class="text-muted font-size-sm">
        Effective {{ formatDate(item.effectiveDate) }}
        <span v-if="item.premium != null" class="ml-2 font-weight-bold text-dark-50">{{ item.premium | currency("$", ",", 0, ".", "front", true) }}</span>
      </div>
    </div>

    <!-- Readiness strip -->
    <div class="work-item-readiness flex-grow-1 px-3">
      <ReadinessStrip :readiness="item.readiness" />
      <NextStepStrip :processing-readiness="item.processingReadiness" />
    </div>

    <!-- Primary next action -->
    <div class="work-item-action pl-3">
      <button
        class="btn btn-sm font-weight-bold text-uppercase"
        :class="actionButtonClass"
        @click.prevent="$emit('action', item)"
      >
        {{ item.nextAction.label }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import ReadinessStrip from "./ReadinessStrip.vue";
import NextStepStrip from "./NextStepStrip.vue";

export default {
  name: "WorkItemRow",

  components: { ReadinessStrip, NextStepStrip },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    isException: function() {
      return this.item.status === "Exception";
    },

    actionButtonClass: function() {
      if (this.isException) {
        return "btn-warning";
      }
      // Routed actions (e.g. Review & Post) are the committing/positive step.
      return this.item.nextAction.route ? "btn-success" : "btn-primary";
    }
  },

  methods: {
    formatDate: function(isoDate) {
      if (!isoDate) {
        return "";
      }
      return moment.tz(isoDate, "YYYY-MM-DD", "Australia/Sydney").format("DD/MM/YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>
.work-item-row {
  background-color: #ffffff;
}

.work-item-row:hover {
  background-color: #f3f6f9;
}

.work-item-identity {
  min-width: 260px;
}

.work-item-exception {
  background-color: #fff4de;
  border-left: 4px solid #ffa800;
}

.work-item-exception:hover {
  background-color: #fdecc8;
}
</style>
